import 'core-js/modules/es.object.assign.js';
import { jsx } from 'react/jsx-runtime';
import { useContext, createContext } from 'react';

const ContainerContext = /*#__PURE__*/createContext({});
const ContainerProvider = ({
  children,
  container
}) => {
  return jsx(ContainerContext.Provider, Object.assign({
    value: container
  }, {
    children: children
  }));
};
const useContainer = () => {
  return useContext(ContainerContext);
};

export { ContainerContext, ContainerProvider, useContainer };
